<main>
  <img src="assets/images/lost.png" alt="Not Found">
  <p>This Page is Lost in Space</p>
  <button routerLink="/">Go Home</button>
</main>
